import type { FinaleScoreEntry } from '../data/finaleGame';

export function FinaleLeaderboard({ scores }: { scores: FinaleScoreEntry[] }) {
  return <section className="finale-leaderboard" aria-label="Shooter high scores">
    <h3>TOP FIVE PLASMA RUNS</h3>
    <ol>{scores.slice(0, 5).map((entry, index) => <li key={`${entry.id ?? entry.recordedAt}-${entry.name}`}><b>{index + 1}</b><span>{entry.name}</span><strong>{entry.score.toString().padStart(7, '0')}</strong><small>LV {entry.cleared}</small></li>)}</ol>
  </section>;
}
